import React, { Fragment, useEffect, useState, useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Card, Table } from "react-bootstrap";
import { styled } from "@mui/material/styles";
import Papa from "papaparse";
import {
  cutAfterDecimal,
  getAllStakeUsers,
  getAllUserList,
} from "../../../services/api_function";
import toast from "react-hot-toast";
import { Tooltip, IconButton } from "@mui/material";
import { FaRegCopy } from "react-icons/fa";
import { useSelector } from "react-redux";
import { lapseWallet, setLapseWallet } from "./web3/transfert";

export default function LapseWalletset() {
  const { wallet } = useSelector((state) => state.login);
  const { walletAddress, chainId } = wallet;

  const [address, setAddress] = useState("");
  const [walletlapesAddress, setwalletlapesAddress] = useState("");


  async function setLapseAddress() {
    const userDetails = localStorage.getItem("adminToken");
    // const parsedDetails = JSON.parse(userDetails);
    const token = userDetails;
    const res = await setLapseWallet(address, token);
    if(res){

    }
  }

  useEffect(()=>{
    lapseWallet().then((res)=>{
        console.log(res,"res::::")
        setwalletlapesAddress(res)
    })
  },[])

  return (
    <Fragment>
      <Row>
        <div className="display_end">
          {/* <div className="input-group" style={{ maxWidth: "300px" }}>
          <input
            type="search"
            id="form1"
            className="form-control"
            placeholder="Search here..."
            onChange={handleSearch}
          />
        </div> */}
          <label className="form-label" for="form1"></label>
        </div>

        <Col lg={12}>
          <Card>
            <Card.Header>
              <Card.Title>set Lapse Wallet</Card.Title>
            </Card.Header>
            <Card.Body>
              <div className="mt-4 mb-4">
                <span className=" p-2 rounded border-dark fw-bold border"> 
                Lapse wallet:  <span className="fw-bold">{walletlapesAddress}</span>
              </span>
              </div>
              <div className="pb-3 d-flex gap-2 pt-4">
                <div className="input-group" style={{ maxWidth: "300px" }}>
                  <input
                    type="search"
                    id="form1"
                    className="form-control"
                    placeholder="Enter  Address"
                    // value={daoAddress}
                    onChange={(e) => {
                      setAddress(e.target.value);
                    }}
                  />
                </div>
                <button
                  className="btn btn-success"
                  onClick={() => {
                    setLapseAddress();
                  }}
                >
                  ADD
                </button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
}
